var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "button",
            { staticClass: "btn btn-secondary", on: { click: _vm.refresh } },
            [_c("i", { staticClass: "fas fa-sync-alt fa-fw" })]
          ),
          _vm._v(" "),
          _vm.canCreate
            ? _c(
                "button",
                { staticClass: "btn btn-purple", on: { click: _vm.onCreate } },
                [_c("i", { staticClass: "far fa-file fa-fw" })]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "align-self-end" },
          [
            _c("input-debounced", {
              staticClass: "search-bar w-300 mb-2",
              attrs: {
                clearable: true,
                autofocus: true,
                placeholder: "Search",
              },
              model: {
                value: _vm.search,
                callback: function ($$v) {
                  _vm.search = $$v
                },
                expression: "search",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("base-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isRefreshing,
            expression: "isRefreshing",
          },
        ],
        ref: "baseTable",
        attrs: {
          "base-url": _vm.urlWithFilters,
          "current-page": _vm.currentPage,
          "element-loading-spinner": "el-icon-loading",
        },
        on: { "load-success": _vm.onLoadSuccess, refresh: _vm.onRefresh },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "el-table",
                  {
                    staticClass: "w-100",
                    attrs: { data: _vm.items, stripe: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "model.id", label: "Id", width: "80" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.to_address",
                        label: "To Address",
                        "min-width": "120",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.fallback_from",
                        label: "Fallback From",
                        "min-width": "120",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.fallback_to",
                        label: "Fallback To",
                        "min-width": "120",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "text-right",
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }